module.exports = __webpack_public_path__ + "static/media/4250.b5be1a50.jpg";